import Monospace from './Monospace'
export default Monospace
